module.exports = __webpack_public_path__ + "static/media/adv.a8a4f33b.jpg";